var removeChildren = require('remove-children');

import { SoftwareAYDriver } from './outputs/soft_ay';
import { SoundtrackerEngine } from './engines/soundtracker';
import { TurbosoundtrackerEngine } from './engines/turbosoundtracker';
import { SampleEditor } from './ui/views/sample_editor';
import { OrnamentEditor } from './ui/views/ornament_editor';
import { NewSongView } from './ui/views/new_song';
import { MainView } from './ui/views/main';
import { Modal } from './ui/views/modal';

var audioContext = null;
function getAudioContext() {
    if (!audioContext) audioContext = new AudioContext();
    return audioContext;
}

class ReverieApp {
    constructor() {
        this.viewport = document.body;

        this.ayDriver = new SoftwareAYDriver(
            getAudioContext,
            1773400,
            'acb',
            2,
        );
        this.engines = [SoundtrackerEngine, TurbosoundtrackerEngine];
        this.enginesByName = {};
        this.engines.forEach((engine) => {
            this.enginesByName[engine.name] = engine;
        });

        let newSongView = new NewSongView(this);
        this.newSongModal = new Modal(newSongView);
        this.newSongModal.render(this.viewport);

        this.clipboard = null;

        this.song = null;
        this.openNewSong(this.engines[0].name);
    }

    openNewSong(engineName) {
        let engine = this.enginesByName[engineName];
        let song = new engine.Song();
        this.openSong(song, engine);
    }

    openSong(song, engine) {
        if (this.song) this.closeSong(this.song);

        this.song = song;
        this.player = new engine.Player(this.ayDriver);
        this.player.openSong(song);

        this.mainView = new MainView(this, engine);
        this.mainView.render(this.viewport);
        this.mainView.bind(song, {
            undoBuffer: song.undoBuffer,
            undoPath: [],
        });
        this.mainView.show();

        this.sampleEditor = new SampleEditor(this, engine.Sample);
        this.sampleEditorModal = new Modal(this.sampleEditor);
        this.sampleEditorModal.render();
        this.sampleEditor.bind(song, {
            undoBuffer: song.undoBuffer,
            undoPath: ['samples'],
        });

        this.ornamentEditor = new OrnamentEditor(this, engine.Ornament);
        this.ornamentEditorModal = new Modal(this.ornamentEditor);
        this.ornamentEditorModal.render();
        this.ornamentEditor.bind(song, {
            undoBuffer: song.undoBuffer,
            undoPath: ['ornaments'],
        });

        this.mainView.patternEditor.focus();
        window.song = song;
    }

    closeSong() {
        this.mainView.unbind();
        this.sampleEditor.unbind();
        this.ornamentEditor.unbind();
        removeChildren(this.viewport);
    }

    openSongFile(file) {
        /* see if any engine has a dedicated importer for this file type */
        for (let engine of this.engines) {
            if (engine.canImport(file)) {
                engine.import(file).then((song) => {
                    this.openSong(song, engine);
                });
                return;
            }
        }

        /* otherwise, open as a native Reverie JSON song file */
        file.text().then((text) => {
            let songData;
            try {
                songData = JSON.parse(text);
            } catch (e) {
                throw 'Invalid song file: ' + e;
            }
            let engine = this.enginesByName[songData.engine || songData.format];
            if (!engine) {
                throw 'Unknown song format: ' + songData.format;
            }
            let song = new engine.Song(songData);
            this.openSong(song, engine);
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new ReverieApp();
});
